const modules = import.meta.glob(
    './hotkeys/use*.mjs',
    {import: 'default', eager: true}
)

export default () => {
    return Object.fromEntries(
        Object.values(modules)
            .map(hook => Object.entries(hook()))
            .flat()
    )
}
